import { ConfigProvider } from 'antd';
import { useMemo } from 'react';

const PRIMARY_COLOR = '#0da49b';

/**
 * Get primary color from CSS variable or fallback to default
 */
const getPrimaryColor = () => {
    if (typeof window !== 'undefined') {
        const root = document.documentElement;
        const computedColor = getComputedStyle(root).getPropertyValue('--primary-color')?.trim();
        if (computedColor) {
            return computedColor;
        }
    }
    return PRIMARY_COLOR;
};

/**
 * @param {Object} props
 * @param {JSX.Element} props.children
 */
function Theme({ children }) {
    const primaryColor = useMemo(() => getPrimaryColor(), []);

    return (
        <ConfigProvider
            theme={{
                token: {
                    colorPrimary: primaryColor,
                },
            }}
        >
            {children}
        </ConfigProvider>
    );
}

export default Theme;
